@if (profile) {
  <div class="callout">
    <div class="upc_top"></div>
    <cm-user-profiles-list [profile]="profile" [profiles]="profiles" />
  </div>
}
